import React, { useState } from "react";
import { View, Text, ScrollView, StyleSheet } from "react-native";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import { Formik } from "formik";
import { Theme } from "../../../theme";
import Button from "../../../forms/button";
import Share from "../../../components/share";
import CopyableText from "../../../components/copyableText";

const handleSubmit = async ({ doStartGame, setGame, id, setIsSubmiting }) => {
  setIsSubmiting(true);

  try {
    const result = await doStartGame({ variables: { id } });
    global.RunningGame.game.status = result.data.startGame.status;

    setGame(result.data.startGame);
  } catch (error) {
    console.log(error);
    setIsSubmiting(false);
  }
};

const PendingGame = (props) => {
  const { game, name } = props;
  const owner = game.owner;

  const [isSubmiting, setIsSubmiting] = useState(false);

  // TODO real user accounts
  const isOwner = name === owner.id;

  const gameContent = Object.keys(game.levelDrinks).map((level) => {
    const levelContent = game.levelDrinks[level];
    return (
      <View style={styles.listContainer} key={level}>
        <Text style={styles.levelHeading}>{level} drinks</Text>
        <View style={styles.drinkText}>
          {levelContent.drinks.map((drink, dIdx) => (
            <Text key={dIdx}>{drink}</Text>
          ))}
        </View>
      </View>
    );
  });

  return (
    <Theme>
      <Formik
        onSubmit={() => {
          handleSubmit({
            doStartGame: props.startGame,
            setGame: props.setGame,
            id: game.id,
            setIsSubmiting,
          });
        }}
        initialValues={{
          id: null,
          name: null,
        }}
        render={({ handleSubmit }) => (
          <ScrollView>
            <View style={styles.container}>
              <View style={styles.textContainer}>
                <Text>
                  Welcome to the game{" "}
                  <Text style={styles.nameText}>{name}.</Text>
                </Text>
                {!isOwner && (
                  <View>
                    <Text>
                      <Text style={styles.ownerText}>{owner.id}</Text> will
                      start the game when everyone has joined.
                    </Text>
                  </View>
                )}
              </View>
              <View style={styles.gameIdContainer}>
                <Text>
                  Game ID:{" "}
                  <CopyableText
                    value={game.id}
                    textStyles={{ ...styles.gameId }}
                  />
                </Text>
                <View style={styles.shareContainer}>
                  <Share gameId={game.id} />
                </View>
              </View>
              <View style={styles.gameContainer}>{isOwner && gameContent}</View>
              <View style={styles.optionsContainer}>
                {isOwner && (
                  <View>
                    <View>
                      <Button
                        title="Start game"
                        disabled={isSubmiting}
                        onPress={() =>
                          handleSubmit({
                            doStartGame: props.startGame,
                            setGame: props.setGame,
                            id: game.id,
                            setIsSubmiting,
                          })
                        }
                      />
                    </View>
                  </View>
                )}
                <View style={{ marginTop: 20 }}>
                  <Text>Please play responsibly.</Text>
                </View>
              </View>
            </View>
          </ScrollView>
        )}
      />
    </Theme>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: "center",
  },
  textContainer: {
    flex: 1,
  },
  gameIdContainer: {
    margin: 10,
    marginTop: 25,
    flexWrap: "wrap",
    alignItems: "flex-start",
    flexDirection: "row",
  },
  shareContainer: {
    position: "relative",
    bottom: 10,
    left: 10,
  },
  gameContainer: {
    flex: 6,
    alignItems: "center",
  },
  optionsContainer: {
    flex: 2,
    justifyContent: "flex-end",
    margin: 20,
    alignItems: "center",
  },
  listContainer: {
    flex: 1,
    alignItems: "center",
    flexDirection: "column",
  },
  nameText: {
    fontWeight: "bold",
  },
  gameId: {
    fontWeight: "bold",
  },
  levelHeading: {
    fontWeight: "bold",
    marginTop: 20,
    marginBottom: 10,
  },
  ownerText: {
    fontWeight: "bold",
  },
  drinkText: {
    flex: 1,
    alignItems: "center",
  },
});

const START_GAME_MUTATION = gql`
  mutation startGameMutation($id: String!) {
    startGame(id: $id) {
      id
      status
    }
  }
`;

const PendingGameWithMutation = graphql(START_GAME_MUTATION, {
  name: "startGame",
})(PendingGame);

export default PendingGameWithMutation;
